import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import classNames from "classnames";
import { ISOToDisplayCode } from "@utils";
import { useRootAppStore } from "@hooks";
import { THEME_SETTINGS } from "@theme-settings";

export default observer(function AutosellButton() {
	const bet = useContext(MyBetsBetContext);
	const store = useRootAppStore().myBetsViewStore;
	const { t } = useTranslation();

	if (store == null || !WEBPACK_IS_AUTOCASHOUT_ENABLED) {
		return null;
	}

	const autoCashoutButtonClasses = classNames(
		"card--bet__btn card--bet__btn--auto btn btn--xsml btn--primary--subtle btn--icon",
		{
			// "bet__btn--autosell--set": bet.isAutoCashoutSet,
		}
	);

	const autoCashoutIconClasses = classNames("u-icon u-icon--tny", {
		"u-icon--settings--str": !bet.isAutoCashoutSet,
		"u-icon--set-stake": bet.isAutoCashoutSet,
	});

	const autoCashoutLabel =
		t("mybets:CASHOUT.AUTO_CASHOUT") +
		(bet.isAutoCashoutSet && bet.betSlipSecureWinSetting != null
			? " " +
				bet.betSlipSecureWinSetting.threshold.toFixed(2) +
				" " +
				ISOToDisplayCode(THEME_SETTINGS.defaultCurrency)
			: "");
	if (
		WEBPACK_IS_AUTOCASHOUT_ENABLED &&
		bet.displayedAmount !== undefined &&
		bet.displayedAmount !== null &&
		bet.displayedAmount !== "0.00"
	) {
		return (
			<>
				<button
					type="button"
					onClick={() =>
						store.cashoutStore.openAutosellModal(bet, true)
					}
					className={autoCashoutButtonClasses}
					title={autoCashoutLabel}
				>
					<i className={autoCashoutIconClasses} />
					<span>
						{t("mybets:CASHOUT.AUTO_CASHOUT")}{" "}
						{bet.isAutoCashoutSet &&
						bet.betSlipSecureWinSetting != null
							? `${bet.betSlipSecureWinSetting.threshold.toFixed(2)} ${ISOToDisplayCode(THEME_SETTINGS.defaultCurrency)}`
							: ""}
					</span>
				</button>
			</>
		);
	} else {
		return null;
	}
});
